import type { FrontendApi, RecoveryFlow } from '@ory/kratos-client';

import { oryClient } from '@revelio/auth';

import { RecoveryForm } from '../components/recovery-form';
import { ThemeLayout } from '../components/theme/theme-layout';

// create a new recovery flow
export function createFlow() {
  return (oryClient as FrontendApi).createBrowserRecoveryFlow().catch((e) => {
    console.info('SDK Error:', e);
    return e;
  });
}

export function getFlow(flowId: string): Promise<{ data: RecoveryFlow }> {
  return (oryClient as FrontendApi)
    .getRecoveryFlow({ id: flowId })
    .catch((e) => {
      console.info('SDK Error:', e);
      return e;
    });
}

function Recovery() {
  return (
    <ThemeLayout variant="centered">
      <RecoveryForm />
    </ThemeLayout>
  );
}

export default Recovery;
